module.exports = "/_next/static/images/text-red-num-1-21b38636.png";